import { AnimatePresence, m, useReducedMotion } from "motion/react";
import type * as React from "react";
import { IconButton } from "../buttons/icon-button";
import { SEARCH_COLORS, SearchTokens } from "./search.tokens";

interface TrailingActionProps {
	query: string;
	trailingIcon?: React.ReactNode;
	avatar?: React.ReactNode;
	onClear: () => void;
}

/** Clear button when query is non-empty, otherwise flexible trailing icon + avatar slots. */
export function TrailingAction({
	query,
	trailingIcon,
	avatar,
	onClear,
}: TrailingActionProps) {
	const shouldReduceMotion = useReducedMotion();

	return (
		<div className="flex shrink-0 items-center gap-2">
			<AnimatePresence mode="wait" initial={false}>
				{query ? (
					<m.div
						key="clear-action"
						initial={shouldReduceMotion ? false : { opacity: 0, scale: 0.8 }}
						animate={{ opacity: 1, scale: 1 }}
						exit={shouldReduceMotion ? {} : { opacity: 0, scale: 0.8 }}
						transition={{ duration: 0.15 }}
						className="flex items-center justify-center"
					>
						<IconButton
							size="sm"
							style={{ color: SEARCH_COLORS.trailingIcon }}
							aria-label="Clear search"
							onClick={onClear}
						>
							<span
								className="material-symbols-rounded select-none leading-none"
								style={{ fontSize: 20 }}
								aria-hidden="true"
							>
								close
							</span>
						</IconButton>
					</m.div>
				) : (
					trailingIcon && (
						<m.span
							key="trailing-icon"
							initial={shouldReduceMotion ? false : { opacity: 0, scale: 0.8 }}
							animate={{ opacity: 1, scale: 1 }}
							exit={shouldReduceMotion ? {} : { opacity: 0, scale: 0.8 }}
							transition={{ duration: 0.15 }}
							className="flex shrink-0 items-center justify-center"
							style={{ color: SEARCH_COLORS.trailingIcon }}
							aria-hidden="true"
						>
							{trailingIcon}
						</m.span>
					)
				)}
			</AnimatePresence>

			{avatar && (
				<span
					className="flex shrink-0 items-center justify-center rounded-full overflow-hidden"
					style={{
						width: SearchTokens.avatarSize,
						height: SearchTokens.avatarSize,
					}}
					aria-hidden="true"
				>
					{avatar}
				</span>
			)}
		</div>
	);
}
